/* -------------------------------------------------------------------------- */
/*                          JobStatusDropdownInput                             */
/* -------------------------------------------------------------------------- */
// Este componente utiliza DropdownInput para generar un JobStatusDropdownInput

import { omit } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
// import Icon from '../../../utility/icomoon';
import Icon from '../../../../../utility/icomoon';
import DropdownInput from '../../../../formComponents/DropdownInput';
import { getJobStatusIcon } from '../../utils';

const JobStatusDropdownInput = (props) => {
  const {
    forceinitialvalue = 8,
    field,
    additionalonchangefunction = (value) => null,
    disabled
  } = props;
  const intl = useIntl();
  const statuses = Array(8)
    .fill(null)
    .map((_, i) => ({
      id: i + 1,
      value: i + 1,
      label: `jobs.status.${i + 1}`,
      iconName: undefined
    }));

  return (
    <DropdownInput
      field={field}
      fieldstate={props.fieldstate}
      {...omit(props, ['forceinitialvalue', 'name', 'field', 'fieldstate'])}
      id={'jobStatus'}
      isDisabled={disabled}
      label={<FormattedMessage id="jobs.status" />}
      options={statuses.map((status) => {
        return {
          ...status,
          icon: <Icon icon={getJobStatusIcon(status.value)} />,
          label: <FormattedMessage id={`jobs.status.${status.value}`} />,
          label_intl: intl.formatMessage({ id: 'jobs.status.' + status.value })
        };
      })}
    />
  );
};

export default JobStatusDropdownInput;
